import usePost from '../api/usePost';
import { useState } from 'react';

function ShipmentForm({notify, visible, setVisible, purchase, setFormSubmitted, formSubmitted, isMulti}) {
  const { postData, isLoading, error } = usePost();
  let is_edit = purchase.shipment
  let tracking_number = is_edit  ? purchase.shipment.tracking_number : ''
  let cost = is_edit  ? purchase.shipment.cost : ''
  let currency = is_edit  ? purchase.shipment.currency : 'EUR'
  const [formData, setFormData] = useState({purchase_id: purchase.id, tracking_number: tracking_number, cost: cost, currency: currency, is_edit: is_edit});
  const handleChange = (e) => {
      const { name, value } = e.target;
      setFormData({ ...formData, [name]: value });
      console.log(formData)
    };
    const handleSubmit = async (e) => {
      e.preventDefault();
      const response = await postData('/create_purchase_shipment', formData);
      if (response) {
        setFormSubmitted(!formSubmitted);
        setVisible(false);
        if (is_edit){
          notify('Shipment Updated Succesfully')
        }
        else {
          notify('Shipment Saved Succesfully')
        }
        
      }
    };
    const handleClose = () => {
        setVisible(false);
      };
  return (
    visible && (<div id="shipment-form">
    <i id="close-shipment-form" className="fas fa-times" onClick={handleClose}></i>
    <form onSubmit={handleSubmit}>
      <div>
        <label htmlFor="tracking-number">Tracking Number:</label>
        <input type="text" id="tracking-number" name="tracking_number" value={formData.tracking_number} onChange={handleChange}/>
        <br />
        <label htmlFor="shipment-cost">
        <i className="fas fa-tags"></i>Shipment Cost:
        </label>
        <input type="text" id="cost" name="cost" value={formData.cost} onChange={handleChange}/>
        <br />
        <label htmlFor="shipment-currency">
          <i className="fas fa-coins"></i>Purchase Currency:
        </label>
        <select id="shipment-currency" name="currency" value={formData.currency} onChange={handleChange}>
          <option value="USD">USD</option>
          <option value="EUR">EUR</option>
          <option value="JPY">JPY</option>
          <option value="GBP">GBP</option>
          <option value="AUD">AUD</option>
        </select>
        <button type="submit">
          <i className="fas fa-save" disabled={isLoading}></i>Save
        </button>
      </div>
    </form>
    {error && <p>Error: {error}</p>}
  </div>)
  )
}

export default ShipmentForm